import { QuickAddComponent } from '@theme/quick-add';

/**
 * Quick view for the homepage product row (sections/dpb-products.liquid).
 *
 * Reuses Horizon's quick-add modal as-is. The stock component only finds the product URL through a
 * `product-card` or `product-hotspot-component` ancestor, which these custom cards don't have, so the
 * URL comes from `data-product-url` instead. Everything else (fetching the product page, the modal,
 * variant picking, add to cart) is Horizon's own code.
 */
class DpbQuickView extends QuickAddComponent {
  get productPageUrl() {
    return this.dataset.productUrl || '';
  }
}

if (!customElements.get('dpb-quick-view')) {
  customElements.define('dpb-quick-view', DpbQuickView);
}
